<div class="padding">
  <b>Filename template:</b>

  <div class="margin-top-small margin-bottom-small unicode bg-light-grey padding-small">
    {{ '{StyleCode}{TeamCode}{ColorCode}_{ShotType}_{AspectRatio}.{FileExtension}' }}
  </div>

  <div class="flex column end margin-top-small">
    <div class="flex center">
      <button (click)="close()" class="stroked">
        <i class="fa-solid fa-check"></i>
        Understand
      </button>
    </div>
  </div>
</div>
